import _ from 'lodash'
import { cvtRouteNodes } from '@/js/utils/routes'
import FeatureConfiguration from '../../FeatureConfiguration/FeatureConfiguration.vue'

export default {
  components: {
    FeatureConfiguration
  },
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {
    onClickFeatureConfig() {
      this.$router.push({
        name: cvtRouteNodes.enterpriseDashboardBranding,
      })
    },
  },
}
